import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})
const user = {
    state: {
        remoteLogin: false,//异地登录
        userInfo: {}, //用户信息
        token: '', //token
        menuScenarioList: [],//场景模拟数据
        courseList: [], //用户课程
        userAuthority:{},//用户权限
        rem: 0
    },

    mutations: {
        SET_USER_INFO(state, user) {
            state.userInfo = Object.assign({}, user);
        },
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_REMOTE_LOGIN(state, remoteLogin) {
            state.remoteLogin = remoteLogin;
        },
        SET_COURSE_LIST(state, courseList) {
            state.courseList = courseList
        },
        SET_SCENARIO_LIST(state, menuScenarioList) {
            state.menuScenarioList = menuScenarioList
        },
        SET_USERAUTHORITY(state,userAuthority){
          state.userAuthority = userAuthority;
        },
        SET_REM(state, rem) {
            state.rem = rem;
        },
    },

    actions: {
        setToken({ commit }, token) {
            commit('SET_TOKEN', token)
        },
        setUserInfo({ commit }, user) {
            commit('SET_USER_INFO', user)
        },
        setRemoteLogin({ commit }, remoteLogin) {
            commit('SET_REMOTE_LOGIN', remoteLogin)
        },
        setCourseList({ commit }, courseList) {
            commit('SET_COURSE_LIST', courseList)
        },
        setScenarioList({ commit }, menuScenarioList) {
            commit('SET_SCENARIO_LIST', menuScenarioList)
        },
        setUserAuthority({ commit },userAuthority){
          commit('SET_USERAUTHORITY', userAuthority)
        },
        setRem({ commit }, rem) {
            commit('SET_REM', rem)
        },
    },
    plugins: [vuexLocal.plugin]
}
export default user




// WEBPACK FOOTER //
// ./src/store/modules/user.js